(() => {
  'use strict';

  const TIME_ZONE = 'Europe/Rome';
  const DURATION_MS = 120 * 60 * 1000;
  const END_NOTICE_MS = 5 * 1000;
  const RESYNC_MS = 5 * 60 * 1000;

  // Gli stessi orari usati dal flusso Shopify Flow.
  const SCHEDULE = Object.freeze({
  Sun: ['00:00', '12:00', '20:00'],
  Mon: ['00:00', '12:00', '20:00'],
  Tue: ['00:00', '12:00', '20:00'],
  Wed: ['00:00', '12:00', '20:00'],
  Thu: ['00:00', '12:00', '20:00'],
  Fri: ['00:00', '12:00', '20:00'],
  Sat: ['00:00', '12:00', '20:00'],
});

  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });

  let serverOffsetMs = 0;

  function nowMs() {
    return Date.now() + serverOffsetMs;
  }

  async function syncServerClock() {
    const requestStarted = Date.now();
    try {
      const response = await fetch(`/cart.js?lsm_clock=${requestStarted}`, {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const requestEnded = Date.now();
      const serverDate = response.headers.get('date');
      if (!serverDate) return;
      const serverMs = Date.parse(serverDate);
      if (!Number.isFinite(serverMs)) return;
      const estimatedResponseTime = requestStarted + (requestEnded - requestStarted) / 2;
      serverOffsetMs = serverMs - estimatedResponseTime;
    } catch (_error) {
      // In assenza della risposta Shopify usa l'orologio del dispositivo.
    }
  }

  function localParts(date) {
    const parts = {};
    for (const part of formatter.formatToParts(date)) {
      if (part.type !== 'literal') parts[part.type] = part.value;
    }
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second),
    };
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function dateKey(parts) {
    return `${parts.year}-${pad(parts.month)}-${pad(parts.day)}`;
  }

  function addDays(key, days) {
    const [year, month, day] = key.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day + days));
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
  }

  function weekdayForKey(key) {
    const [year, month, day] = key.split('-').map(Number);
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
  }

  // Converte un orario locale di Roma in epoch, compresi i cambi ora legale/solare.
  function localEpoch(key, time) {
    const [year, month, day] = key.split('-').map(Number);
    const [hour, minute] = time.split(':').map(Number);
    const wallClockUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
    let candidate = wallClockUtc;

    for (let attempt = 0; attempt < 4; attempt += 1) {
      const zoned = localParts(new Date(candidate));
      const representedAsUtc = Date.UTC(
        zoned.year,
        zoned.month - 1,
        zoned.day,
        zoned.hour,
        zoned.minute,
        zoned.second,
      );
      const nextCandidate = wallClockUtc - (representedAsUtc - candidate);
      if (nextCandidate === candidate) break;
      candidate = nextCandidate;
    }
    return candidate;
  }

  function windowsAround(instantMs) {
    const today = dateKey(localParts(new Date(instantMs)));
    const windows = [];

    for (let dayOffset = -1; dayOffset <= 8; dayOffset += 1) {
      const key = addDays(today, dayOffset);
      const weekday = weekdayForKey(key);
      for (const time of SCHEDULE[weekday] || []) {
        const start = localEpoch(key, time);
        windows.push({ start, end: start + DURATION_MS });
      }
    }

    return windows.sort((a, b) => a.start - b.start);
  }

  function currentState(instantMs) {
    const windows = windowsAround(instantMs);
    const active = windows.find((window) => instantMs >= window.start && instantMs < window.end);
    const ended = [...windows].reverse().find((window) => window.end <= instantMs);
    const next = windows.find((window) => window.start > instantMs);

    if (active) {
      return {
        state: 'active',
        label: 'I LUCCHETTI SONO APERTI si chiuderanno tra',
        remaining: active.end - instantMs,
      };
    }

    if (ended && instantMs - ended.end < END_NOTICE_MS) {
      return {
        state: 'ended',
        label: 'PROMO FLASH TERMINATA',
        remaining: 0,
      };
    }

    return {
      state: 'waiting',
      label: 'I LUCCHETTI SI APRIRANNO TRA',
      remaining: next ? next.start - instantMs : 0,
    };
  }

  function formatDuration(milliseconds) {
    const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return [hours, minutes, seconds].map(pad).join(':');
  }

  function timerMarkup(extraClass = '') {
    const element = document.createElement('span');
    element.className = `lsm-promo-timer ${extraClass}`.trim();
    element.setAttribute('role', 'timer');
    element.setAttribute('aria-live', 'polite');
    const locksAsset = window.lsmPromoLocksAssetUrl || '/assets/lucchetti-locks.png';
    element.innerHTML = [
      `<span class="lsm-promo-timer__locks" aria-hidden="true"><img src="${locksAsset}" alt="" loading="lazy" width="70" height="56"></span>`,
      '<span class="lsm-promo-timer__label" data-lsm-promo-label>I LUCCHETTI SI APRIRANNO TRA</span>',
      '<time class="lsm-promo-timer__clock" data-lsm-promo-clock>00:00:00</time>',
    ].join('');
    return element;
  }

  function ensureTimers() {
    // Il timer principale è già presente nel layout, sopra l’intero sito.
    // Nei banner prodotto il contatore e le condizioni vengono aggiunti solo se mancano.
    const termsTemplate = document.getElementById('lsm-promo-terms-product-template');

    document.querySelectorAll('.promo-product-banner, .promo-3x2-status').forEach((banner) => {
      if (!banner.querySelector('.lsm-promo-timer')) {
        banner.appendChild(timerMarkup('lsm-promo-timer--product'));
      }

      if (!banner.querySelector('[data-lsm-promo-terms]') && termsTemplate?.content) {
        banner.appendChild(termsTemplate.content.cloneNode(true));
      }
    });
  }

  function updateTimers() {
    ensureTimers();
    const status = currentState(nowMs());
    const display = formatDuration(status.remaining);

    document.querySelectorAll('.lsm-promo-timer').forEach((timer) => {
      timer.classList.toggle('is-active', status.state === 'active');
      timer.classList.toggle('is-ended', status.state === 'ended');
      timer.dataset.state = status.state;

      const label = timer.querySelector('[data-lsm-promo-label]');
      const clock = timer.querySelector('[data-lsm-promo-clock]');
      if (label) label.textContent = status.label;
      if (clock) {
        clock.hidden = status.state === 'ended';
        clock.textContent = display;
      }
    });
  }

  function setupTermsToggles() {
    if (document.documentElement.dataset.lsmPromoTermsReady === 'true') return;
    document.documentElement.dataset.lsmPromoTermsReady = 'true';

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-lsm-promo-terms-toggle]');
      if (!toggle) return;

      const container = toggle.closest('[data-lsm-promo-terms]');
      const panel = container?.querySelector('[data-lsm-promo-terms-panel]');
      if (!container || !panel) return;

      const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      panel.hidden = !shouldOpen;
      container.classList.toggle('is-open', shouldOpen);
    });
  }

  function start() {
    setupTermsToggles();
    ensureTimers();
    updateTimers();
    syncServerClock().finally(updateTimers);

    window.setInterval(updateTimers, 1000);
    window.setInterval(() => syncServerClock().finally(updateTimers), RESYNC_MS);


    document.addEventListener('shopify:section:load', updateTimers);
    window.addEventListener('pageshow', updateTimers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
